import { FeatureCard } from "@/design-system/Organisms";
import { featureCards } from "@/design-system/Organisms/FeatureCard/FeatureCard.config";
import { useScrollToSection } from "@/hooks/useScrollToSection";

const HomeFeatureCardSection = () => {
  const { ref } = useScrollToSection<HTMLElement>({
    behavior: 'smooth',
    block: 'start',
    offset: 80
  });
  return (
    <section ref={ref} id="feature-section" className="pt-40 bg-white px-4 md:px-auto">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
          {featureCards.map((card, idx) => (
            <FeatureCard
              key={idx}
              title={card.title}
              description={card.description}
              link={card.link}
              image={card.image}
              backgroundClass={card.backgroundClass}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeFeatureCardSection;
